function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-arrangeForward");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-arrangeForward",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(5.500000, 4.100000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  points: "4 13.375 19 13.375 15 16.375 0 16.375"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13,8.375 L19,8.375 L15,10.375 L13,10.375 M7,10.375 L0,10.375 L4,8.375 L7,8.375",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,3.125 L3.5,7.09952229 L7.5,11.125 M16.25,7.125 L4.5,7.125",
  id: "Combined-Shape",
  transform: "translate(10.000000, 7.125000) rotate(90.000000) translate(-10.000000, -7.125000) "
}))));

const SvgIco30ArrangeForward = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30ArrangeForward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-arrangeForward.1e20e2e7.svg";
export { ForwardRef as ReactComponent };